import React from 'react';
import { motion } from 'framer-motion';
const bonuses = [{
  title: 'BONO 1: BONUS CREATOR (GPT)',
  subtitle: 'Crea Bonos Irresistibles en Minutos',
  desc: 'Genera bonos de alto impacto que elevan el valor de tu oferta y te ayudan a mejorar conversiones sin complicar tu producto.',
  image: 'https://i.postimg.cc/28DV0rfs/33e4a121.png',
  price: '$12.00 USD'
}, {
  title: 'BONO 2: COPY ADS (GPT)',
  subtitle: 'Generador de Copys para Anuncios',
  desc: 'Transforma tus ideas en copys claros y persuasivos, listos para testear en Meta Ads.',
  image: 'https://i.postimg.cc/bJnwRFVp/ff7692d8-min.png',
  price: '$12.00 USD'
}, {
  title: 'BONO 3: WADS (GPT)',
  subtitle: 'Generador de Guiones de Venta para WhatsApp',
  desc: 'Obtén guiones para responder dudas, manejar objeciones y cerrar con naturalidad sin sonar insistente.',
  image: 'https://i.postimg.cc/rwYy2L7j/a2aa6413-min.png',
  price: '$12.00 USD'
}, {
  title: 'BONO 4: AUTO PAGE (GPT)',
  subtitle: 'Generador de Guiones de Venta para Páginas de Ventas',
  desc: 'Diseña guiones para tu landing page (titulares, secciones, bullets, FAQ y CTAs) para publicar más rápido y optimizar con datos.',
  image: 'https://i.postimg.cc/Y2fpqFJb/d48b3706-min.png',
  price: '$12.00 USD'
}];
export function MechanismSection() {
  return <section className="w-full py-16 px-6 bg-[#0a0f0d]" data-id="element-66">
      <div className="max-w-4xl mx-auto space-y-10" data-id="element-67">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center space-y-4" data-id="element-68">
          <h2 className="text-3xl md:text-5xl font-bold text-[#f0f0f0]" data-id="element-69">
            Además, hoy te llevas 4 GPTs extra sin costo adicional
          </h2>
          <p className="text-[#00d4aa] text-xl font-medium" data-id="element-70">
            (valor referencial: $48 USD)
          </p>
        </motion.div>

        <div className="space-y-6" data-id="element-71">
          {bonuses.map((bono, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-[#050505] border-l-4 border-[#00d4aa] rounded-r-xl p-6 md:p-8 flex flex-col md:flex-row items-center md:items-start gap-8 shadow-lg" data-id="element-72">
              <div className="w-full md:w-48 flex-shrink-0" data-id="element-73">
                <img src={bono.image} alt={bono.title} className="w-full h-auto rounded-lg shadow-md" data-id="element-74" />
              </div>
              <div className="flex-1 space-y-4 text-center md:text-left" data-id="element-75">
                <h3 className="text-xl font-bold text-white" data-id="element-76">{bono.title}</h3>
                <h4 className="text-lg text-gray-300 font-medium" data-id="element-77">
                  {bono.subtitle}
                </h4>
                <p className="text-gray-400 leading-relaxed" data-id="element-78">{bono.desc}</p>
                <div className="pt-2 text-sm" data-id="element-79">
                  <span className="text-gray-500 line-through mr-2" data-id="element-80">
                    Precio normal: {bono.price}
                  </span>
                  <span className="text-[#00d4aa] font-bold" data-id="element-81">Hoy: Gratis</span>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="pt-4 text-center" data-id="element-82">
          <a href="https://aprendeemprendearg.com/cart/52712282784111:1" target="_blank" rel="noopener noreferrer" onClick={() => {
          if (window.fbq) {
            window.fbq('track', 'InitiateCheckout', {
              content_name: 'EBOOK CREATOR',
              content_category: 'GPT',
              value: 18990,
              currency: 'ARS'
            });
          }
        }} className="w-full md:w-auto inline-block bg-[#00d4aa] hover:bg-[#00bfa0] text-black font-bold text-lg px-10 py-5 rounded-lg transition-all transform hover:scale-105 no-underline" data-id="element-83">
            Acceder ahora con todos los bonos
          </a>
        </motion.div>
      </div>
    </section>;
}